import { render, staticRenderFns } from "./stocktake-review.vue?vue&type=template&id=36394e04&"
import script from "./stocktake-review.vue?vue&type=script&lang=js&"
export * from "./stocktake-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports